// extracted by mini-css-extract-plugin
export default {"articleTitle":"certificateCharge_articleTitle__CyJ61","row":"certificateCharge_row__j7wmW"};